const countryAdapter = countries => {
  return countries.sort((a, b) =>
    a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase())
  );
};

export default countryAdapter;
